import { createApp } from 'vue';
import Body from "@/scripts/woocommerce/cart/Body.vue";

class App
{
	constructor()
	{
		this.init();
	}

	init() {
		/**
		 * Body vue application (child of document body)
		 */
		const div = document.createElement('div');
		div.setAttribute('id', 'vue-body');
		document.body.append(div);
		const body = createApp(Body);
		body.mount('#vue-body');
	}
}

new App();
